import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff82b120"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-signature" }
const _hoisted_2 = { class: "uf-signature__content" }
const _hoisted_3 = { class: "uf-signature__canvas" }
const _hoisted_4 = {
  ref: "signature",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_5 = { class: "footer footer1" }
const _hoisted_6 = { class: "footer footer2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff"} }, "加载中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      "lazy-render": false,
      style: { width: '100%', height: '100%' },
      onOpen: _ctx.onOpen,
      onClose: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("canvas", _hoisted_4, null, 512),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
              }, "返回"),
              _createElementVNode("span", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "清除"),
              _createElementVNode("span", {
                class: "btn blue",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, "提交")
            ], 512), [
              [_vShow, _ctx.orientation != 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: "btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popupShow = false))
              }, "返回"),
              _createElementVNode("span", {
                class: "btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "清除"),
              _createElementVNode("span", {
                class: "btn blue",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, "提交")
            ], 512), [
              [_vShow, _ctx.orientation == 0]
            ]),
            _createVNode(_component_van_overlay, { show: _ctx.overlayShow }, {
              default: _withCtx(() => [
                _createVNode(_component_van_loading, {
                  size: "24px",
                  vertical: "",
                  color: "#ffffff",
                  style: {"color":"#fff"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpen", "onClose"])
  ]))
}